'Attachment'.datatype()
'datatype'.field({caption: 'Document Type'})
'theParentId'.field({numeric: true, indexed: true})
'parentReference'.field({caption: 'Reference'})
'attachmentType'.field({caption: 'Type'})
'description'.field()
'attachedDate'.field({date: true})
'contents'.field({caption: "Attachment File", file: true})
'fileName'.field()

'attachmentType'.options(['Proforma', 'Invoice', 'Customs', 'Bill', 'Transport', 'Other'])

'attachmentType'.inception('Other')

'attachedDate'.inception(async attachment => {
  return global.todayYMD()
})

'parentReference'.calculate(async attachment => {
  let datatype = attachment.datatype; if ( ! datatype ) return ''
  let cast = await datatype.bringSingle({id: attachment.theParentId}); if ( ! cast ) return ''
  return cast.keyValue()
})

'parentReference'.destination(async attachment => {
  let datatype = attachment.datatype; if ( ! datatype ) return
  let res = await datatype.bringFirst({id: attachment.theParentId})
  return res
})

'Attachment'.beforeSaving(async function() {
  if ( ! this.contents )
    throw(new Error('Please choose a file to upload'))
})
